// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import FieldData from './FieldData';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Pagination,
//   Select,
// } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   setAllServices,
//   setSearchFilter,
//   setServiceForFilter,
//   resetFilters,
//   setItemsPerPage,
//   setCurrentPage,
// } from 'src/redux/slices/servicesSlice';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// import * as XLSX from 'xlsx';
// import SearchImg from '../../assets/search.svg';
// import Book1service from '../../assets/excel/Book1service.xlsx';

// const filterServiceFor = [
//   { value: 'Female', label: 'Female' },
//   { value: 'Male', label: 'Male' },
//   { value: 'Both', label: 'Both' },
// ];

// const AllServices = () => {
//   const dispatch = useDispatch();
//   const [showLoader, setShowLoader] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [uploadedData, setUploadedData] = useState(null);
//   const [checkedServices, setCheckedServices] = useState([]);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const { fetchAllServices, activeBranchId, createManyService, setShowMessage, deleteManyService } =
//     useMain();

//   const newData = useSelector((state) => state.service.services);
//   const filteredData = useSelector((state) => state.service.filteredServices);
//   const filter = useSelector((state) => state.service.filters);
//   const pagination = useSelector((state) => state.service.pagination);
  
//   useEffect(() => {
//     getData();
//   }, [activeBranchId]);

//   useEffect(() => {
//     dispatch(setAllServices(newData)); // Update the services data
//   }, [newData]);

//   useEffect(() => {
//     dispatch(resetFilters()); // Reset filters on load
//   }, []);

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//         const jsonData = XLSX.utils.sheet_to_json(firstSheet);
//         setUploadedData(jsonData);
//       };
//       reader.readAsArrayBuffer(selectedFile);
//     }
//   };
//   const handleBulkDelete = async () => {
//     setOpenDialogue(true);
//   };
//   const getData = async () => {
//     try {
//       setShowLoader(true);
//       const res = await fetchAllServices(activeBranchId);
//       if (res.statusCode === 200) {
//         dispatch(setAllServices(res?.data));
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     dispatch(setSearchFilter(e.target.value)); // Update search filter
//   };

//   const handleGenderChange = (e) => {
//     dispatch(setServiceForFilter(e.target.value)); // Update gender filter
//   };

//   const handleLimitChange = (e) => {
//     dispatch(setItemsPerPage(e.target.value)); // Update limit
//   };

//   const handlePageChange = (e, page) => {
//     dispatch(setCurrentPage(page)); // Update the current page
//   };

//   const clearDataHandler = () => {
//     dispatch(resetFilters()); // Reset filters
//     getData(); // Re-fetch data without filters
//   };

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     if (uploadedData) {
//       setShowLoader(true);
//       try {
//         const res = await createManyService(activeBranchId, { bulkData: uploadedData });
//         setShowMessage({
//           message:
//             res?.statusCode === 200
//               ? 'Service was successfully uploaded'
//               : 'Service failed to upload',
//           messageType: res?.statusCode === 200 ? 'success' : 'error',
//         });
//         getData();
//       } catch (error) {
//         setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//       } finally {
//         setShowLoader(false);
//         closeModal();
//       }
//     }
//   };

//   const downloadExcelTemplate = () => {
//     const templateFileName = Book1service;

//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = templateFileName;
//     a.download = 'service_template.xlsx';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   };

//   const submitBulkDelete = async () => {
//     try {
//       setDeleteLoading(true);
//       const serviceIds = checkedServices.map((service) => service?._id);

//       const payload = {
//         ids: serviceIds,
//       };

//       const response = await deleteManyService(payload, activeBranchId);

//       if (response.statusCode === 200) {
//         setShowMessage({ message: 'Successfully deleted Services', messageType: 'success' });
//         setCheckedServices([]);
//         getData();
//       } else {
//         setShowMessage({
//           message: response.message || 'Error occurred while deleting Services',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setDeleteLoading(false);
//       setOpenDialogue(false);
//     }
//   };

//   return (
//     <PageContainer title="Manage Services" description="this contains all products">
//       <DashboardCard2 title="Manage Services">
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             marginBottom: '1.7rem',
//           }}
//         >
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             <InputLabel>Show per page</InputLabel>
//             <Select
//               style={{
//                 borderRadius: '7px',
//                 border: '0.5px solid #6174DD',
//                 padding: '4px 12px',
//                 background: '#FFF',
//                 height: '40px',
//               }}
//               value={pagination.itemsPerPage}
//               onChange={handleLimitChange}
//             >
//               <MenuItem value={10}>10</MenuItem>
//               <MenuItem value={50}>50</MenuItem>
//               <MenuItem value={100}>100</MenuItem>
//               <MenuItem value={200}>200</MenuItem>
//             </Select>
//           </div>

//           <div style={{ display: 'flex', alignItems: 'center', marginRight: '-a1rem' }}>
//             <div style={{ marginRight: '1rem' }}>
//               <InputLabel style={{ marginRight: '0.5rem' }}>Gender</InputLabel>
//               <Select
//                 style={{
//                   borderRadius: '7px',
//                   border: '0.5px solid #6174DD',
//                   padding: '4px 12px',
//                   background: '#FFF',
//                   height: '40px',
//                   width: '140px',
//                 }}
//                 value={filter.serviceFor}
//                 onChange={handleGenderChange}
//               >
//                 {filterServiceFor.map((item, index) => (
//                   <MenuItem key={index} value={item.value}>
//                     {item.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </div>

//             <div
//               style={{ marginRight: '0rem' }}
//               onClick={() => document.getElementById('search-input').focus()}
//             >
//               <InputLabel style={{ marginRight: '0.5rem' }}>Search</InputLabel>
//               <div className="search-input" style={{ display: 'flex', alignItems: 'center' }}>
//                 <img src={SearchImg} alt="" style={{ marginRight: '0.5rem' }} />
//                 <input
//                   id="search-input"
//                   type="text"
//                   value={filter.search}
//                   onChange={handleSearchChange}
//                   style={{ borderRadius: '7px' }}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <Grid container justifyContent="flex-end">
//           <Grid item justifyContent="flex-end">
//             {checkedServices.length ? (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 sx={{ background: '#ff4d4d', '&:hover': { background: '#ff6666' } }}
//                 onClick={handleBulkDelete}
//               >
//                 Delete
//               </Button>
//             ) : (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 sx={{ background: '#6174DD' }}
//                 onClick={openModal}
//               >
//                 Services Upload
//               </Button>
//             )}
//           </Grid>
//         </Grid>

//         {/* Modal Dialog */}
//         <Dialog open={isModalOpen} onClose={closeModal}>
//           <DialogTitle>Create Many Services</DialogTitle>
//           <form onSubmit={handleFormSubmit}>
//             <Box p={2}>
//               <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
//             </Box>
//             {showLoader && <ShowLoader />}
//             <Box p={2}>
//               <Button type="submit" variant="contained" color="primary">
//                 Submit
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="primary"
//                 sx={{ ml: 2 }}
//                 onClick={downloadExcelTemplate}
//               >
//                 <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
//                 Sample Download
//               </Button>
//             </Box>
//           </form>
//         </Dialog>

//         <Dialog open={openDialogue} onClose={() => setOpenDialogue(false)}>
//           <DialogTitle>Delete service</DialogTitle>
//           <DialogContent>
//              <DialogContentText>Are you sure you want to delete this Service?</DialogContentText>
//           </DialogContent>
//           <DialogActions>
//              <Button onClick={() => setOpenDialogue(false)}>Cancel</Button>
//             <Button onClick={submitBulkDelete} autoFocus>
//               Delete
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {showLoader ? (
//           <ShowLoader />
//         ) : filteredData.length > 0 ? (
//           <Box>
//             <Grid container spacing={3}>
//               <Grid item xs={12}>
//                 <FieldData
//                   data={filteredData}
//                   getServices={getData}
//                   setCheckedServices={setCheckedServices}
//                   checkedServices={checkedServices}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         ) : (
//           'No data found'
//         )}

//         <Box display={'flex'} justifyContent={'flex-end'}>
//           <Pagination
//             count={pagination.totalPages}
//             page={pagination.currentPage}
//             color="primary"
//             onChange={handlePageChange}
//           />
//         </Box>
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default AllServices;

//new filter 
import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import FieldData from './FieldData';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  IconButton,
    ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAllServices,
  setSearchFilter,
  setServiceForFilter,
  resetFilters,
  setItemsPerPage,
  setCurrentPage,
  setCategoryFilter,
} from 'src/redux/slices/servicesSlice';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import * as XLSX from 'xlsx';
import SearchImg from '../../assets/search.svg';
import Book1service from '../../assets/excel/Book1service.xlsx';
import ServiceFilter from './ServiceFilter';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import BulkUploadServiceDialog from './components/BulkUploadServiceDialog'; 
import CategoryWiseServices from './components/CategoryWiseServices'; 
import CategoryIcon from '@mui/icons-material/Category';
import ListIcon from '@mui/icons-material/List';

const filterServiceFor = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
  { value: 'Both', label: 'Both' },
];
const AllServices = () => {
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedData, setUploadedData] = useState(null);
  const [checkedServices, setCheckedServices] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [viewMode, setViewMode] = useState('list'); // 'list' | 'categories'
  const [categoryData, setCategoryData] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const { fetchAllServices, activeBranchId, createManyService, setShowMessage, deleteManyService, getAppointmentPageData  } =
    useMain();

  // Using displayedServices for table and filteredServices for "no data"
  const newData = useSelector((state) => state.service.services);
  const filteredData = useSelector((state) => state.service.filteredServices);
  const displayed = useSelector((state) => state.service.displayedServices);
  const filter = useSelector((state) => state.service.filters);
  const pagination = useSelector((state) => state.service.pagination);

  useEffect(() => {
    getData();
  }, [activeBranchId]);

  useEffect(() => {
    dispatch(setAllServices(newData)); // Update the services data in redux (will apply filters)
  }, [newData]);

  useEffect(() => {
      dispatch(resetFilters()); 
    }, []);
  useEffect(() => {
    if (viewMode === 'categories' && activeBranchId) {
      loadCategoryData();
    }
  }, [viewMode, activeBranchId]);

  const loadCategoryData = async () => {
    setCategoryLoading(true);
    try {
      const res = await getAppointmentPageData(activeBranchId);
      if (res?.statusCode === 200) {
        setCategoryData(res.data?.services || []); // .services is the categorizedServicesArray
      } else {
        setShowMessage({ message: res?.message || 'Failed to load categories', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setCategoryLoading(false);
    }
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const data = new Uint8Array(ev.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);
        // console.log(jsonData,"jsonDataaa")
        // setUploadedData(jsonData);
        // Map Excel columns to database keys, supporting both camelCase and Space Case headers
        const formattedData = jsonData.map((item) => ({
          serviceName: item.serviceName || item['serviceName'],
          category: item.category || item['category'],
          price: item.price || item['price'],
          duration: item.duration || item['duration'],
          serviceFor: item.serviceFor || item['serviceFor'],
          taxStatus: (item.taxStatus || item['taxStatus']) === 'Exclusive' ? 'withoutTax' : (item.taxStatus || item['taxStatus']) === 'Inclusive' ? 'withTax' : 'noGst',
          reminderDays: item.reminderDays || item['reminderDays'],
        }));
        setUploadedData(formattedData);
      
      };
      reader.readAsArrayBuffer(selectedFile);
    }
  };

  const handleBulkDelete = async () => {
    setOpenDialogue(true);
  };

  const getData = async () => {
    try {
      setShowLoader(true);
      const res = await fetchAllServices(activeBranchId);
      if (res.statusCode === 200) {
        dispatch(setAllServices(res?.data || []));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    dispatch(setSearchFilter((e.target.value || '').trimStart()));
  };

  // Trims the pasted text, then inserts it at the cursor position
  const handleSearchPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();
    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    dispatch(setSearchFilter(next));
  };

  // Trims trailing spaces when the user leaves the box
  const handleSearchBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      dispatch(setSearchFilter(trimmed));
    }
  };

  const handleGenderChange = (e) => {
    dispatch(setServiceForFilter(e.target.value || ''));
  };

  const handleLimitChange = (e) => {
    dispatch(setItemsPerPage(e.target.value));
  };

  const handlePageChange = (e, page) => {
    dispatch(setCurrentPage(page));
  };

  const clearDataHandler = () => {
    dispatch(resetFilters());
    getData();
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (uploadedData) {
      setShowLoader(true);
      try {
        const res = await createManyService(activeBranchId, { bulkData: uploadedData });
        setShowMessage({
          message: res?.statusCode === 200 ? 'Service was successfully uploaded' : 'Service failed to upload',
          messageType: res?.statusCode === 200 ? 'success' : 'error',
        });
        getData();
      } catch (error) {
        setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
      } finally {
        setShowLoader(false);
        closeModal();
      }
    }
  };

  const downloadExcelTemplate = () => {
    // const templateFileName = Book1service;
    // const a = document.createElement('a');
    // a.style.display = 'none';
    // a.href = templateFileName;
    // a.download = 'service_template.xlsx';
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    const headers = [
      "serviceName",
      "category",
      "price",
      "duration",
      "serviceFor",
      "taxStatus",
      "reminderDays"
    ];

    const sampleData = [
      {
        "serviceName": "Hair Cut",
        "category": "Hair",
        "price": 500,
        "duration": 30,
        "serviceFor": "Male",
        "taxStatus": "Inclusive",
        "reminderDays": "10"
      },
      {
        "serviceName": "Skin Treatment",
        "category": "Skin",
        "price": 2000,
        "duration": 60,
        "serviceFor": "Female",
        "taxStatus": "Exclusive",
        "reminderDays": "35"
      },
    ];

    const ws = XLSX.utils.json_to_sheet(sampleData, { header: headers });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Services");
    XLSX.writeFile(wb, "service_template.xlsx");
        closeModal();

  };

  const submitBulkDelete = async () => {
    try {
      setDeleteLoading(true);
      const serviceIds = checkedServices.map((service) => service?._id);
      const payload = { ids: serviceIds };
      const response = await deleteManyService(payload, activeBranchId);

      if (response.statusCode === 200) {
        setShowMessage({ message: 'Successfully deleted Services', messageType: 'success' });
        setCheckedServices([]);
        getData();
      } else {
        setShowMessage({ message: response.message || 'Error occurred while deleting Services', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setDeleteLoading(false);
      setOpenDialogue(false);
    }
  };

  return (
<PageContainer title="Manage Services" description="this contains all products">
  <DashboardCard2 title="Manage Services">
   {/* Row 1 — Tab toggle, on its own line above everything else */}
        <div style={{ display: 'flex', marginBottom: '1rem' }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newMode) => newMode && setViewMode(newMode)}
            sx={{
              borderRadius: '30px',
              height: '40px',
              backgroundColor: '#f0f0f0',
              border: '1px solid #cfcece',
              display: 'flex',
              gap: '2px',
            }}
          >
            <ToggleButton
              value="list"
              sx={{
                color: '#000',
                backgroundColor: '#fafafa',
                padding: '0 20px',
                borderRadius: '30px',
                border: 'none',
                '&.Mui-selected': {
                  backgroundColor: '#6174DD',
                  color: '#fff',
                  border: 'none',
                  '&:hover': {
                    backgroundColor: '#6174DD',
                  },
                },
                '&:not(.Mui-selected)': {
                  '&:hover': {
                    backgroundColor: '#d0d0d0',
                  },
                },
              }}
            >
              By Service
            </ToggleButton>
            <ToggleButton
              value="categories"
              sx={{
                color: '#000',
                backgroundColor: '#fafafa',
                padding: '0 20px',
                borderRadius: '30px',
                border: 'none',
                '&.Mui-selected': {
                  backgroundColor: '#6174DD',
                  color: '#fff',
                  border: 'none',
                  '&:hover': {
                    backgroundColor: '#6174DD',
                  },
                },
                '&:not(.Mui-selected)': {
                  '&:hover': {
                    backgroundColor: '#d0d0d0',
                  },
                },
              }}
            >
              By Category
            </ToggleButton>
          </ToggleButtonGroup>
        </div>

        {/* Row 2 — Show per page / Search / Filter / Upload-Delete (unchanged, as it was originally) */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-end', 
          marginBottom: '1.7rem' 
        }}>
          {/* Left side - Show per page */}
          <div>
            <InputLabel>Show per page</InputLabel>
            <Select
              style={{ 
                borderRadius: '7px', 
                border: '0.5px solid #6174DD', 
                padding: '4px 12px', 
                background: '#FFF', 
                height: '40px',
                width: '100px'
              }}
              value={pagination.itemsPerPage}
              onChange={handleLimitChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={200}>200</MenuItem>
            </Select>
          </div>

          {/* Right side - Search, Filter and Upload/Delete button */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'flex-end', 
            gap: '0.8rem'
          }}>
            {/* Search */}
            <div style={{ width: '170px', flexShrink: 0 }} onClick={() => document.getElementById('search-input').focus()}>
              <InputLabel>Search</InputLabel>
              <div 
                className="search-input" 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  border: '0.5px solid #6174DD',
                  borderRadius: '7px',
                  padding: '4px 12px',
                  background: '#FFF',
                  height: '40px',
                  width: '100%',
                  maxWidth: 'none',
                  boxSizing: 'border-box',
                  marginBottom:'2px'
                }}
              >
                <img src={SearchImg} alt="" style={{ marginRight: '8px' }} />
                <input
                  id="search-input"
                  type="text"
                  placeholder="Search Services..."
                  value={filter.search || ''}
                  onChange={handleSearchChange}
                  onPaste={handleSearchPaste}
                  onBlur={handleSearchBlur}
                  style={{ 
                    flex: 1, 
                    border: 'none', 
                    outline: 'none',
                    background: 'transparent',
                    height: '100%'
                  }}
                />
                {filter.search && (
                  <IconButton
                    onClick={() => dispatch(setSearchFilter(''))}
                    style={{ padding: 1 }}
                  >
                    <ClearIcon style={{
                                      color: '#000',
                                      marginRight: '-0.2rem',
                                      marginTop: '0.1rem',
                                      fontSize: '1.1rem'
                                    }} />
                  </IconButton>
                )}
              </div>
            </div>

            {/* Filter */}
            <div style={{marginTop:'0px'}}>
              <ServiceFilter
                services={newData}
                value={[
                  ...(filter.serviceFor ? [filter.serviceFor] : []),
                  ...(filter.category ? [filter.category] : []),
                  ...(filter.search ? [filter.search] : []),
                ]}
                onChange={(selectedValues) => {
                  const genders = selectedValues.filter((val) => ['Female', 'Male', 'Both'].includes(val));
                  const categories = selectedValues.filter((val) => newData.some((s) => s.category === val));
                  const serviceNames = selectedValues.filter((val) => newData.some((s) => s.serviceName === val));

                  dispatch(setServiceForFilter(genders.length > 0 ? genders[0] : ''));
                  dispatch(setCategoryFilter(categories.length > 0 ? categories[0] : ''));
                  dispatch(setSearchFilter(serviceNames.length > 0 ? serviceNames[0] : ''));
                }}
                placeholder="Filters"
              />
            </div>

            {/* Upload/Delete Button */}
            <div style={{marginBottom:'1px', display: 'flex', gap: '0.8rem'}}>
              {checkedServices.length ? (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ 
                    background: '#ff4d4d', 
                    height: '40px',
                    minWidth: '120px',
                    '&:hover': { 
                      background: '#ff6666' 
                    } 
                  }}
                  onClick={handleBulkDelete}
                >
                  Delete
                </Button>
              ) : (
                <BulkUploadServiceDialog
                  onUploaded={getData}
                  existingServices={newData}
                />
              )}
            </div>
          </div>
        </div>

    {/* Modal Dialog */}
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>Create Many Services</DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <Box p={2}>
          <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
        </Box>
        {showLoader && <ShowLoader />}
        <Box p={2}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
          <Button variant="outlined" color="primary" sx={{ ml: 2 }} onClick={downloadExcelTemplate}>
            <ArrowCircleDownIcon sx={{ margin: '0px 2px 0px 0px' }} />
            Sample Download
          </Button>
        </Box>
      </form>
    </Dialog>

    <Dialog open={openDialogue} onClose={() => setOpenDialogue(false)}>
      <DialogTitle>Delete service</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this Service?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDialogue(false)}>Cancel</Button>
        <Button onClick={submitBulkDelete} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>

    {viewMode === 'categories' ? (
      categoryLoading ? (
        <ShowLoader />
      ) : (
        <CategoryWiseServices data={categoryData} activeBranchId={activeBranchId} />
      )
    ) : showLoader ? (
      <ShowLoader />
    ) : filteredData.length > 0 ? (
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FieldData
              data={displayed}
              getServices={getData}
              setCheckedServices={setCheckedServices}
              checkedServices={checkedServices}
            />
          </Grid>
        </Grid>
      </Box>
    ) : (
      'No data found'
    )}

    {viewMode === 'list' && (
      <Box display={'flex'} justifyContent={'flex-end'} mt={2}>
        <Pagination 
          count={pagination.totalPages} 
          page={pagination.currentPage} 
          color="primary" 
          onChange={handlePageChange} 
        />
      </Box>
    )}
  </DashboardCard2>
</PageContainer>
  );
};

export default AllServices;


//new ui
// import React, { useEffect, useState } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import FieldData from './FieldData';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Pagination,
//   Select,
//   Chip,
//   Card,
//   CardContent,
//   TextField,
//   FormControl,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   setAllServices,
//   setSearchFilter,
//   setServiceForFilter,
//   resetFilters,
//   setItemsPerPage,
//   setCurrentPage,
// } from 'src/redux/slices/servicesSlice';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import {
//   Search,
//   Upload,
//   Download,
//   ChevronLeft,
//   ChevronRight,
//   X,
// } from '@mui/icons-material';
// import DeleteOutline from '@mui/icons-material/DeleteOutline';
// import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
// import * as XLSX from 'xlsx';
// import Book1service from '../../assets/excel/Book1service.xlsx';

// const filterServiceFor = [
//   { value: '', label: 'All' },
//   { value: 'Female', label: 'Female' },
//   { value: 'Male', label: 'Male' },
//   { value: 'Both', label: 'Both' },
// ];

// const AllServices = () => {
//   const dispatch = useDispatch();
//   const [showLoader, setShowLoader] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [uploadedData, setUploadedData] = useState(null);
//   const [checkedServices, setCheckedServices] = useState([]);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const { fetchAllServices, activeBranchId, createManyService, setShowMessage, deleteManyService } =
//     useMain();

//   const newData = useSelector((state) => state.service.services);
//   const filteredData = useSelector((state) => state.service.filteredServices);
//   const filter = useSelector((state) => state.service.filters);
//   const pagination = useSelector((state) => state.service.pagination);
  
//   useEffect(() => {
//     getData();
//   }, [activeBranchId]);

//   useEffect(() => {
//     dispatch(setAllServices(newData));
//   }, [newData]);

//   useEffect(() => {
//     dispatch(resetFilters());
//   }, []);

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
//         const jsonData = XLSX.utils.sheet_to_json(firstSheet);
//         setUploadedData(jsonData);
//       };
//       reader.readAsArrayBuffer(selectedFile);
//     }
//   };

//   const handleBulkDelete = async () => {
//     setOpenDialogue(true);
//   };

//   const getData = async () => {
//     try {
//       setShowLoader(true);
//       const res = await fetchAllServices(activeBranchId);
//       if (res.statusCode === 200) {
//         dispatch(setAllServices(res?.data));
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   const handleSearchChange = (e) => {
//     dispatch(setSearchFilter(e.target.value));
//   };

//   const handleGenderChange = (e) => {
//     dispatch(setServiceForFilter(e.target.value));
//   };

//   const handleLimitChange = (e) => {
//     dispatch(setItemsPerPage(e.target.value));
//   };

//   const handlePageChange = (e, page) => {
//     dispatch(setCurrentPage(page));
//   };

//   const clearFilters = () => {
//     dispatch(resetFilters());
//     getData();
//   };

//   const openModal = () => setIsModalOpen(true);
//   const closeModal = () => setIsModalOpen(false);

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     if (uploadedData) {
//       setShowLoader(true);
//       try {
//         const res = await createManyService(activeBranchId, { bulkData: uploadedData });
//         setShowMessage({
//           message:
//             res?.statusCode === 200
//               ? 'Service was successfully uploaded'
//               : 'Service failed to upload',
//           messageType: res?.statusCode === 200 ? 'success' : 'error',
//         });
//         getData();
//       } catch (error) {
//         setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//       } finally {
//         setShowLoader(false);
//         closeModal();
//       }
//     }
//   };

//   const downloadExcelTemplate = () => {
//     const templateFileName = Book1service;
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = templateFileName;
//     a.download = 'service_template.xlsx';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   };

//   const submitBulkDelete = async () => {
//     try {
//       setDeleteLoading(true);
//       const serviceIds = checkedServices.map((service) => service?._id);
//       const payload = { ids: serviceIds };
//       const response = await deleteManyService(payload, activeBranchId);

//       if (response.statusCode === 200) {
//         setShowMessage({ message: 'Successfully deleted Services', messageType: 'success' });
//         setCheckedServices([]);
//         getData();
//       } else {
//         setShowMessage({
//           message: response.message || 'Error occurred while deleting Services',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setDeleteLoading(false);
//       setOpenDialogue(false);
//     }
//   };

//   const hasActiveFilters = filter.search || filter.serviceFor;
//   const totalPages = Math.ceil(filteredData.length / pagination.itemsPerPage) || 1;

//   return (
//     <PageContainer title="Manage Services" description="this contains all products">
//       <DashboardCard2 title="Manage Services">
//         {/* Header */}
//         <Box sx={{ mb: 4 }}>
//           <h1 className="text-3xl font-bold text-foreground mb-2">Service Management</h1>
//           <p className="text-muted-foreground">
//             Manage your salon services efficiently
//           </p>
//         </Box>

//         {/* Filters and Actions */}
//         <Card sx={{ mb: 4, p: 3 }}>
//           <Box sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, gap: 2, mb: 2 }}>
//             {/* Search */}
//             <Box sx={{ flex: 1, position: 'relative' }}>
//               <Search 
//                 sx={{ 
//                   position: 'absolute', 
//                   left: 12, 
//                   top: '50%', 
//                   transform: 'translateY(-50%)', 
//                   color: 'text.secondary',
//                   fontSize: 20
//                 }} 
//               />
//              <TextField
//               placeholder="Search by name, category, gender, or price..."
//               value={filter.search}
//               onChange={handleSearchChange}
//               sx={{
//               '& .MuiOutlinedInput-root': {
//                pl: 4.5,
//               },
//             width: '250px'  // Reduced from 100%
//             }}
//            />
//             </Box>

//             {/* Gender Filter */}
//             <FormControl sx={{ minWidth: 140 }}>
//               <InputLabel>Gender</InputLabel>
//               <Select
//                 value={filter.serviceFor}
//                 onChange={handleGenderChange}
//                 label="Gender"
//               >
//                 {filterServiceFor.map((item, index) => (
//                   <MenuItem key={index} value={item.value}>
//                     {item.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* Items per page */}
//             <FormControl sx={{ minWidth: 140 }}>
//               <InputLabel>Show per page</InputLabel>
//               <Select
//                 value={pagination.itemsPerPage}
//                 onChange={handleLimitChange}
//                 label="Show per page"
//               >
//                 <MenuItem value={10}>10 per page</MenuItem>
//                 <MenuItem value={25}>25 per page</MenuItem>
//                 <MenuItem value={50}>50 per page</MenuItem>
//                 <MenuItem value={100}>100 per page</MenuItem>
//               </Select>
//             </FormControl>

//             {hasActiveFilters && (
//               <IconButton onClick={clearFilters} color="primary">
//                 <X />
//               </IconButton>
//             )}
//           </Box>

//           {/* Action Buttons */}
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={checkedServices.length === filteredData.length && filteredData.length > 0}
//                   onChange={(e) => {
//                     if (e.target.checked) {
//                       setCheckedServices(filteredData);
//                     } else {
//                       setCheckedServices([]);
//                     }
//                   }}
//                 />
//               }
//               label={
//                 <span style={{ fontSize: '0.875rem', color: 'text.secondary' }}>
//                   {checkedServices.length > 0
//                     ? `${checkedServices.length} selected`
//                     : 'Select all'}
//                 </span>
//               }
//             />

//             <Box sx={{ flex: 1 }} />

//             {checkedServices.length > 0 ? (
//               <Button
//                 variant="contained"
//                 color="error"
//                 onClick={handleBulkDelete}
//               >
//                <DeleteOutline className="h-4 w-4 mr-2" />
//   Delete Selected ({checkedServices.length})
//               </Button>
//             ) : (
//               <Button
//                 variant="contained"
//                 onClick={openModal}
//                 startIcon={<Upload />}
//                 sx={{ background: '#6174DD' }}
//               >
//                 Bulk Upload
//               </Button>
//             )}
//           </Box>

//           {/* Results Summary */}
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//             <Chip 
//               label={`${filteredData.length} service${filteredData.length !== 1 ? 's' : ''} found`}
//               variant="outlined"
//             />
//             {hasActiveFilters && (
//               <Chip label="Filters active" variant="outlined" color="primary" />
//             )}
//           </Box>
//         </Card>

//         {/* Services Content */}
//         {showLoader ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 }}>
//             <ShowLoader />
//           </Box>
//         ) : filteredData.length === 0 ? (
//           <Card sx={{ textAlign: 'center', py: 10 }}>
//             <Box sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 64, height: 64, borderRadius: '50%', bgcolor: 'grey.100', mb: 3 }}>
//               <Search sx={{ fontSize: 32, color: 'text.secondary' }} />
//             </Box>
//             <h3 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '0.5rem' }}>
//               No services found
//             </h3>
//             <p style={{ color: 'text.secondary', marginBottom: '1rem' }}>
//               {hasActiveFilters
//                 ? 'Try adjusting your filters'
//                 : 'Get started by uploading services'}
//             </p>
//             {hasActiveFilters && (
//               <Button variant="outlined" onClick={clearFilters}>
//                 Clear Filters
//               </Button>
//             )}
//           </Card>
//         ) : (
//           <>
//             <FieldData
//               data={filteredData}
//               getServices={getData}
//               setCheckedServices={setCheckedServices}
//               checkedServices={checkedServices}
//             />

//             {/* Pagination */}
//             {totalPages > 1 && (
//               <Card sx={{ p: 3, mt: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                   <Box sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
//                     Showing {((pagination.currentPage - 1) * pagination.itemsPerPage) + 1}-
//                     {Math.min(pagination.currentPage * pagination.itemsPerPage, filteredData.length)} of{' '}
//                     {filteredData.length}
//                   </Box>
                  
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <IconButton
//                       onClick={() => dispatch(setCurrentPage(Math.max(1, pagination.currentPage - 1)))}
//                       disabled={pagination.currentPage === 1}
//                     >
//                       <ChevronLeft />
//                     </IconButton>
                    
//                     <Box sx={{ display: 'flex', gap: 0.5 }}>
//                       {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                         let pageNum;
//                         if (totalPages <= 5) {
//                           pageNum = i + 1;
//                         } else if (pagination.currentPage <= 3) {
//                           pageNum = i + 1;
//                         } else if (pagination.currentPage >= totalPages - 2) {
//                           pageNum = totalPages - 4 + i;
//                         } else {
//                           pageNum = pagination.currentPage - 2 + i;
//                         }
                        
//                         return (
//                           <Button
//                             key={pageNum}
//                             variant={pagination.currentPage === pageNum ? 'contained' : 'outlined'}
//                             onClick={() => dispatch(setCurrentPage(pageNum))}
//                             sx={{ minWidth: 40, height: 40 }}
//                           >
//                             {pageNum}
//                           </Button>
//                         );
//                       })}
//                     </Box>
                    
//                     <IconButton
//                       onClick={() => dispatch(setCurrentPage(Math.min(totalPages, pagination.currentPage + 1)))}
//                       disabled={pagination.currentPage === totalPages}
//                     >
//                       <ChevronRight />
//                     </IconButton>
//                   </Box>
//                 </Box>
//               </Card>
//             )}
//           </>
//         )}

//         {/* Dialogs */}
//         <Dialog 
//          open={isModalOpen} 
//          onClose={closeModal} 
//          maxWidth="sm" 
//          fullWidth
//           sx={{
//     '& .MuiDialog-paper': {
//       width: '400px',
//       maxWidth: '100%'
//     }
//   }}>
//           <DialogTitle>Bulk Upload Services</DialogTitle>
//           <form onSubmit={handleFormSubmit}>
//             <DialogContent>
//               <DialogContentText sx={{ mb: 3 }}>
//                 Upload an Excel file to add multiple services at once
//               </DialogContentText>
//               <Box sx={{ spaceY: 2, py: 1 }}>
//                 <Card variant="outlined" sx={{ border: 2, borderStyle: 'dashed', p: 1, textAlign: 'center' }}>
//                   <Upload sx={{ fontSize: 32, color: 'text.secondary', mb: 1, mx: 'auto' }} />
//                   <Button component="label" variant="text" color="primary">
//                     Choose a file
//                     <input
//                       type="file"
//                       accept=".xlsx, .xls"
//                       onChange={handleFileChange}
//                       hidden
//                     />
//                   </Button>
//                   {uploadedData && (
//                     <p style={{ fontSize: '0.875rem', color: 'text.secondary', marginTop: 1 }}>
//                       {uploadedData.length} records found
//                     </p>
//                   )}
//                 </Card>
//                 <Button variant="outlined" fullWidth onClick={downloadExcelTemplate} startIcon={<Download />} sx={{p:1,marginTop:1}}>
//                   Download Template
//                 </Button>
//               </Box>
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={closeModal}>Cancel</Button>
//               <Button 
//                 type="submit" 
//                 variant="contained" 
//                 disabled={!uploadedData || showLoader}
//                 sx={{ background: '#6174DD' }}
//               >
//                 {showLoader ? 'Uploading...' : 'Upload'}
//               </Button>
//             </DialogActions>
//           </form>
//         </Dialog>

//         <Dialog open={openDialogue} onClose={() => setOpenDialogue(false)}>
//           <DialogTitle>Delete Multiple Services</DialogTitle>
//           <DialogContent>
//             <DialogContentText>
//               Are you sure you want to delete {checkedServices.length} service(s)? This action cannot be undone.
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpenDialogue(false)}>Cancel</Button>
//             <Button 
//               onClick={submitBulkDelete} 
//               color="error" 
//               variant="contained"
//               disabled={deleteLoading}
//             >
//               {deleteLoading ? 'Deleting...' : 'Delete All'}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </DashboardCard2>
//     </PageContainer>
//   );
// };

// export default AllServices;

